import React from 'react'
import './table-list.scss'

let uniqueIdCount = 0
let idsDic = {}
function getUniqId(prepend) {
  let key = `${prepend}_${uniqueIdCount++}`

  idsDic[key] = 1
  return key
}
function doColumns(columnArray) {
  return columnArray.map((content, idx) => (
    <div
      className="f-table-list__record__cell"
      key={getUniqId('column-' + idx)}
    >
      {content}
    </div>
  ))
}
function doRows(rows, rowClass) {
  return rows.map((columns, idx) => (
    <div
      className={'f-table-list__record ' + rowClass}
      key={getUniqId('row-' + idx)}
    >
      {doColumns(columns)}
    </div>
  ))
}
export default function TableList({ header = [], records = [] }) {
  return (
    <div className="f-table-list" key={getUniqId('table-')}>
      <div className="f-table-list__header">{doRows([header], '--header')}</div>
      <div className="f-table-list__body">{doRows(records, '')}</div>
    </div>
  )
}
